import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "./Header";
import MedexOVA from "./MedexOVA";
import { Phone, EnvelopeSimple, MapPin, ShieldCheck } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="border-t border-[#E2E0D8] bg-bone" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <BrandMark />
          <p className="mt-4 max-w-sm text-sm text-slate-600 leading-relaxed">
            Medex Transportation Services LLC — an NEMT facilitator serving patients nationwide, in
            partnership with <span className="text-ova font-semibold">OVA</span>, a nationwide, fully
            autonomous rideshare platform.
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-bold">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-brandblue/30 bg-brandblue-soft px-3 py-1 text-brandblue-deep">
              <ShieldCheck size={12} weight="bold" /> HIPAA Compliant
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-forest/30 bg-forest-soft px-3 py-1 text-forest">
              10+ Years Experience
            </span>
          </div>
        </div>
        <div>
          <h4 className="font-heading text-sm font-semibold text-slate_navy mb-3">Explore</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><a href="/#services" className="hover:text-brandblue">Services</a></li>
            <li><a href="/#who-we-serve" className="hover:text-brandblue">Who We Serve</a></li>
            <li><a href="/#partnership" className="hover:text-brandblue">Partnership</a></li>
            <li><Link to="/book" className="hover:text-brandblue">Book a Trip</Link></li>
            <li><Link to="/sms-terms" className="hover:text-brandblue" data-testid="footer-sms-terms-link">SMS Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-brandblue" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/admin/login" className="hover:text-brandblue">Admin</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-sm font-semibold text-slate_navy mb-3">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-600">
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-0.5 text-brandblue shrink-0" />
              <a href="tel:+12544671577" className="hover:text-brandblue">+1 (254) 467-1577</a>
              <span className="text-slate-400 text-xs">· main line</span>
            </li>
            <li className="flex items-start gap-2">
              <EnvelopeSimple size={16} className="mt-0.5 text-brandblue shrink-0" />
              <a href="mailto:info@medexova.com" className="hover:text-brandblue break-all">info@medexova.com</a>
            </li>
            <li className="flex items-start gap-2">
              <EnvelopeSimple size={16} className="mt-0.5 text-brandblue shrink-0" />
              <a href="mailto:Shanev@medexova.com" className="hover:text-brandblue break-all">Shanev@medexova.com</a>
              <span className="text-slate-400 text-xs">· partnerships</span>
            </li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-brandblue" /> HQ: Houston, TX · Serving nationwide</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E2E0D8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Medex Transportation Services LLC. All rights reserved.</p>
          <p>NEMT facilitator, powered by next-generation autonomous technology — serving nationwide as <MedexOVA />.</p>
        </div>
      </div>
    </footer>
  );
}
